export default "__VITE_ASSET__Byejd0rp__"